import { WidgetStreamRpcConfig } from 'widgets/streaming/WidgetStreamConfig';
import { ExpertiseResponse } from 'communication/types/expertise/ExpertiseResponse';
import { ExpertiseStreamRequest } from 'communication/types/expertise/ExpertiseStreamRequest';
import { ExpertiseWidgetType } from 'widgets/expertise/ExpertiseWidgetStrategy';
import { ExpertiseReportType } from 'communication/types/expertise/ExpertiseReportType';
import { buildExpertiseHandlers } from './handlers';
import { createExpertiseStreamRequest } from './ExpertiseStreamRequest';
import { clearExpertiseDataAction } from './actions';

export const streamConfig: (
    expertiseWidgetType: ExpertiseWidgetType,
    reportType: ExpertiseReportType
) => WidgetStreamRpcConfig<ExpertiseStreamRequest, ExpertiseResponse> = (
    expertiseWidgetType,
    reportType
) => ({
    streamType: 'RpcStream',
    configType: 'OrderIdsDependentWidgetStreamConfig',
    startChannelDestination: 'startExpertiseByOrderIdsStream',
    createPayload: createExpertiseStreamRequest(reportType),
    clearWidgetStreamData: clearExpertiseDataAction(expertiseWidgetType),
    buildHandlers: buildExpertiseHandlers(expertiseWidgetType),
});
